import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatMessage } from '../Chat'

@InputType()
export class GetRecentChatMessagesArgs extends ActionArgs {
  @Field(() => Date)
  startDateTime: Date
}

export interface IGetRecentChatMessages extends IAction<ChatMessage[], GetRecentChatMessagesArgs> {}
